// @flow strict

import * as React from 'react'

import type { Overdraft } from './types'
import styles from './OverdraftFeeCalculator.module.scss'

type Props = {|
  overdraft: Overdraft,
  id: string,
  max?: ?number,
  onChange: Overdraft => void,
|}

function OverdraftSliderGroup({ overdraft, id, onChange, max }: Props) {
  const { amount, days } = overdraft
  return (
    <>
      <div className={styles.row}>
        <label className={styles.label} htmlFor={`${id}-amount`}>
          Amount to borrow
        </label>
        <input
          type="range"
          id={`${id}-amount`}
          min="0"
          max="3000"
          className={styles.slider}
          value={amount}
          onChange={e =>
            onChange({ ...overdraft, amount: parseInt(e.currentTarget.value) })
          }
          step="50"
        />
        <div className={styles.sliderAmount}>
          <output htmlFor={`${id}-amount`} className={styles.amount}>
            &pound;
            {amount.toLocaleString('en-GB')}
          </output>
          {max != null && amount === max && (
            <div className={styles.sliderFootnote}>max*</div>
          )}
          {max != null && amount > max && (
            <div className={styles.sliderFootnote}>unarranged*</div>
          )}
        </div>
      </div>
      <div className={styles.row}>
        <label className={styles.label} htmlFor={`${id}-days`}>
          Number of days
        </label>
        <input
          type="range"
          id={`${id}-days`}
          min="1"
          max="31"
          className={styles.slider}
          value={days}
          onChange={e =>
            onChange({ ...overdraft, days: parseInt(e.currentTarget.value) })
          }
          step="1"
        />
        <output
          className={`${styles.sliderAmount} ${styles.amount}`}
          htmlFor={`${id}-days`}
        >
          {days}
        </output>
      </div>
    </>
  )
}

export default OverdraftSliderGroup
